import React from 'react';
import SvgIcon from 'src/react_components/svg-icon';

export type DoneIndicatorProps = {
  wrapperClassName?: string;
  labelClassName?: string;
};

const DoneIndicator = ({
  wrapperClassName = 'ms-1',
  labelClassName = 'visually-hidden'
}: DoneIndicatorProps) => (
  <span className={`d-inline-flex align-items-center ${wrapperClassName}`}>
    <SvgIcon icon="check" className="icon-sm mb-0 text-success flex-shrink-0" aria-hidden />
    <span className={labelClassName}>Done</span>
  </span>
);

export default DoneIndicator;
